export class EmployeeList {
	public empCd: string
	public empNm: string
	public empEmail: string
	public divisionCd: string
	public divisionNm: string
	public empTypeCd: string
	public empTyprNm: string
	public workPlace: string
	public password: string
	public renewDate: string
}
